// import moment from 'moment'

const state = {
    id:0,
    bimbel_kelas: '',
    bimbel_kurikulum: '',
    bimbel_mapel: '',
    bimbel_name: '',
    bimbel_start: '',
    bimbel_end:'',
    bimbel_description: '',
    picture_url: null,

    //paket mapel
    mapel_name: '',
    mapel_grade: '',
    mapel_semester: '',
    mapel_kurikulum: '',
    mapel_mapel: ''
  }
  
  const mutations = {
    bimbel_reset: function(state) {
      state.id = 0
      state.bimbel_kelas = ''
      state.bimbel_kurikulum = ''
      state.bimbel_mapel = []
      state.bimbel_name = ''
      state.bimbel_start = ''
      state.bimbel_end = ''
      state.bimbel_description = ''
    },
    bimbel_init: function(state, payload) {
        state.id = 0
        state.bimbel_kelas = ''
        state.bimbel_kurikulum = ''
        state.bimbel_mapel = []
        state.bimbel_name = ''
        state.bimbel_start = ''
        state.bimbel_end = ''
        state.bimbel_description = ''
    },
    bimbel_set_id: function(state, payload) {
      state.id = payload
    },
    bimbel_set_bimbel_kelas: function(state, payload) {
      state.bimbel_kelas = payload
    },
    bimbel_set_bimbel_description: function(state, payload) {
      state.bimbel_description = payload
    },
    bimbel_set_bimbel_kurikulum: function (state, payload) {
      state.bimbel_kurikulum = payload
    },
    bimbel_set_bimbel_name: function (state, payload) {
      state.bimbel_name = payload
    },
    bimbel_set_bimbel_mapel: function (state, payload) {
      state.bimbel_mapel = payload
    },
    bimbel_set_bimbel_start: function(state, payload) {
      state.bimbel_start = payload
    },
    bimbel_set_bimbel_end: function(state, payload) {
      state.bimbel_end = payload
    },
    bimbel_set_picture_url: function(state, payload) {
      state.picture_url = payload
    },

    //paket mapel
    mapel_reset: function(state) {
        state.id = 0
        state.mapel_grade = ''
        state.mapel_kurikulum = ''
        state.mapel_mapel = []
        state.mapel_name = ''
        state.mapel_semester = ''
    },
    bimbel_set_mapel_name: function(state, payload) {
        state.mapel_name = payload
    },
    bimbel_set_mapel_kurikulum: function(state, payload) {
        state.mapel_kurikulum = payload
    },
    bimbel_set_mapel_grade: function(state, payload) {
        state.mapel_grade = payload
    },
    bimbel_set_mapel_mapel: function(state, payload) {
        state.mapel_mapel = payload
    },
    bimbel_set_mapel_semester: function(state, payload) {
        state.mapel_semester = payload
    }
  }
  
  const getters = {
  //   openedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutStartTime = moment(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime)
  //     })
  
  //     return time
  //   },
  //   closedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutEndTime = moment(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime)
  //     })
  
  //     return time
  //   }
  }
  
  export default {state, mutations, getters}
  


// WEBPACK FOOTER //
// ./src/store/modules/bimbel.js